// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { DAMAGE_CASE_DELETE_PICTURE } from "./constants"
import * as Screens from "../screens"

export function discardPicture(caseId, nr) {
  return {
    type: DAMAGE_CASE_DELETE_PICTURE,
    data: { caseId, nr },
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case DAMAGE_CASE_DELETE_PICTURE:
      const { caseId, nr } = action.data
      const damageCase = state.unsentCases[caseId]
      const pictures = damageCase.pictures.filter((_, idx) => idx !== nr - 1)
      const alteredCase = { ...damageCase, pictures }
      return {
        ...state,
        screen: pictures.length === 0 ? Screens.PICTURES_CAMERA : state.screen,
        focusedPictureNr: state.focusedPictureNr && Math.min(pictures.length, state.focusedPictureNr),
        unsentCases: { ...state.unsentCases, [caseId]: alteredCase },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/discardPicture.js